import { Col, Row, Button, Table, Card } from "react-bootstrap";
import * as yup from "yup";
import React, { useEffect, useState, Fragment} from "react";
//import MultiselectTreeCtrl from  "../dashboard/userDashboard/MultiselectTreeCtrl";
import {useLazyAddEditFacilitiesQuery} from "app/redux/Facility/facilityApi";
import {ArrowLeftCircle} from "react-bootstrap-icons";
import {BiSave} from "react-icons/bi";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { toast } from "react-toastify";
import AccessPointModal from "./modal/AccessPointModal";
import AccessPointIncExclPU from "./modal/AccessPointIncExcPU";
import { useLazyGetFacilityDetailByFacilityIdQuery } from "app/redux/Facility/facilityApi";
import { useSelector } from "react-redux";
import { useLazyGetPropertyFloorEntranceQuery } from "app/redux/Building/buildingApi";
import {useLazyGetAMSSyncAccessGroupQuery} from "app/redux/AMS/amsApi";
import { mergeAMSVendorAccessGroupData } from "../AccessGroup/Class/MergeAMSVendorAccessGroupData"; 
function AccessPointDetails({ open,  eventObject, handleSubmit, closeDialog, screenType  }){
    const [accessGroupModalState, setAccessGroupModalState] = useState({
        AccessGroupModalObject: {},
        AccessGroupDialogOpen: false,
        
    });
    const [InclExclPUModalState, setInclExclPUModalState] = useState({
      InclExclPUModalObject: {},
      InclExclPUDialogOpen: false,
      
    });
    const [getAMSSyncAccessGroup] = useLazyGetAMSSyncAccessGroupQuery();
    const [getPropertyFloorEntrance] = useLazyGetPropertyFloorEntranceQuery();
    const [getFacilityDetailByFacilityId] = useLazyGetFacilityDetailByFacilityIdQuery();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [accessData, setAccessDataState] = useState([]);
    const [accessGroupList, setAccessGroupList] = useState([]);
    const [propertyUnitDetails, setPropertyUnitDetails] = useState([]);
    const [addEditFacilities] = useLazyAddEditFacilitiesQuery();
    const [OptionsPUIncluded, setOptionsPUIncluded] = useState(eventObject.OptionsPUIncluded);
    const [OptionsPUExcluded, setOptionsPUExcluded] = useState(eventObject.OptionsPUExcluded);
    const [groupedData, setGroupedData] = useState({});
    const [FacilityIncludedPU, setFacilityIncludedPU] = useState(eventObject.item.IncludedPU);
    const [FacilityExcludedPU, setFacilityExcludedPU] = useState(eventObject.item.ExcludedPU);
    console.log('OptionsAccessGroup -- ', eventObject.OptionsAccessGroup);
    let OptionsAccessGroup = eventObject.OptionsAccessGroup;
    //const OptionsPUIncluded = eventObject.OptionsPUIncluded;
    //const OptionsPUExcluded = eventObject.OptionsPUExcluded;
    const PlacementName = eventObject.item.PlacementName;
    //let FacilityIncludedPU = eventObject.item.IncludedPU;
    //let FacilityExcludedPU = eventObject.item.ExcludedPU;
    const { selectedCompanyId } = useSelector((state) => state.company);
    const initialState = {
      loginUserName: localStorage.getItem("loginUserName") ?? "",
      loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
      loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
    };
    let selectedAccessGroups = [];
    let selectedIncludePropUnits = getDefaultSelectedFromOptions(OptionsPUIncluded);
    let selectedExcludePropUnits = getDefaultSelectedFromOptions(OptionsPUExcluded);
    const propertyFloorEntranceList = useSelector((state) => {
      return state.building.BuildingFloorEntranceList;
    });


    let amssynccompanyAccessGroupList = useSelector((state) => {
        return state.ams.amssynccompanyAccessGroupList;
      });

    useEffect(() => {
        if(eventObject.callingScreen === "ACCESSPOINT"){
          if(propertyFloorEntranceList && propertyFloorEntranceList.length <= 0){
            setPropertyUnitDetails(propertyFloorEntranceList);
          }
         
          let tempdata = eventObject.groupData;
          let selectedItems = eventObject.selectedGroup;
          MarkAccessGroupList(tempdata, selectedItems)
        }
        else{
          getFacilityDataByID(eventObject.facilityId);
        }
      }, []);

      const MarkAccessGroupList = (tempdata, selectedItems) => {
        
        if(tempdata && Array.isArray(tempdata) && tempdata.length > 0){
          //  console.log('USEEFFECT ---------------------------------- ',);
           //Select preselect data
           if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
             tempdata.forEach((item) => {
                 let ConcatID = item.ConcatID;
                 if(item.checked === true){
                     item.checked =  false;
                 }
                 if(item.type === 'custom'){
                  var check1 = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'custom');
                  if(check1 && check1.length > 0){
                      item.checked = true;
                  }
                 }
                 else{
                  var check = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'Direct');
                  if(check && check.length > 0){
                      item.checked = true;
                  }
                  let entrance = item.children;
                  if(entrance && Array.isArray(entrance) && entrance.length > 0){
                      entrance.forEach((entraceitem) => {
                          var entranceCheck = selectedItems.filter(a => a.ConcatID === entraceitem.ConcatID&& a.AccessType === 'Direct');
                          if(entranceCheck && entranceCheck.length > 0){
                              entraceitem.checked = true;
                          }
                          let floor = entraceitem.children;
                          if(floor && Array.isArray(floor) && floor.length > 0){
                              floor.forEach((floorItem) => {
                                  var floorCheck = selectedItems.filter(a => a.ConcatID === floorItem.ConcatID&& a.AccessType === 'Direct');
                                  if(floorCheck && floorCheck.length > 0){
                                      floorItem.checked = true;
                                  }
                              });
                              entraceitem.children = floor;
                          }
                      });
                      item.children = entrance;
                  }
                 }
                 
             });
         }
           
           selectedAccessGroups = prepareDefaultSelectedAccessGroup(tempdata, selectedItems);
           console.log('setAccessGroupList -- ', selectedAccessGroups);
           setAccessGroupList(selectedAccessGroups);
           const groupedData = convertAccessGroupToHeirarchy(selectedAccessGroups);
            setGroupedData(groupedData);
           setAccessDataState(tempdata);
       }
       else{
           setAccessDataState(tempdata);
       }
      }

      const getPropertyUnitData = async () => {
        let data = [];
        const data2 = await getPropertyFloorEntrance({
          propertyid: 0,
          type: "FORFACILITY",
        }).then((result) => {
          if (result.data.data.PropertyUnitsDetail?.length > 0) {
              let puData = result.data.data.PropertyUnitsDetail
              data = mergePropertyUnitArrayObject(puData);
              return data;
          }
        }, error => {
          return data;
        });
        return data2;
      }

      const getAccessGroupData = async () => {
        let data = [];
        if (selectedCompanyId) {
          localStorage.setItem('CompanyId',selectedCompanyId);
          const data2 = await getPropertyFloorEntrance({
            propertyid: 0,
            type: "FORFACILITY",
          }).then((result) => {
            //console.log('getPropertyFloorEntrance - ',result);
            if (result.data.data.AccessGroupDetail?.length > 0) {
              data = mergeArrayInObject(result.data.data.AccessGroupDetail);
              return data;
            }
          }, error => {
            return data;
          });
          return data2;
        }
    
       
      }
      const mergePropertyUnitArrayObject = (rawData) =>
        {
          let mainObj = [];
          if (Array.isArray(rawData)){
            rawData.forEach((item) => {
              let tempObj = {};
              tempObj = item;
              tempObj = {
                ...item,
                value: item.ID,
                ConcatName: item.Name,
                label: item.Name,
                checked: false,
                children: []
              };
              mainObj.push(tempObj);
            });
          }
          setPropertyUnitDetails(mainObj);
          return mainObj;
        }

        const mergeArrayInObject = (rawData) =>
          {
            let mainObj = [];
            if (Array.isArray(rawData)){
              rawData.forEach((item) => {
                let tempObj = {};
                tempObj = item;
                tempObj = {
                  ...item,
                  value: item.ConcatID ,
                  label: item.UnitName,
                  checked: false,
                  children: []
                };
                if (item.PropertyEntranceFloors){
                  const entranceData = JSON.parse(item.PropertyEntranceFloors);
                  entranceData.forEach((entranceItem) => {
                    let entranceTempObj = {};
                    entranceTempObj = {
                      ...entranceItem,
                      value: entranceItem.ConcatID ,
                      label: entranceItem.UnitName,
                      checked: false,
                      children: []
                    };
                    const floorEntranceData = entranceItem.PropertyFloors;
                    if (floorEntranceData){
                      floorEntranceData.forEach((floorEntranceItem) => {
                        let floorTempObj = {};
                        floorTempObj = {
                          ...floorEntranceItem,
                          value: floorEntranceItem.ConcatID ,
                          label: floorEntranceItem.UnitName,
                          checked: false
                        };
                        entranceTempObj.children.push(floorTempObj);
                      });
                    }
                    tempObj.children.push(entranceTempObj);
                  });
                }
                mainObj.push(tempObj);
              });
            }
            return mainObj;
          }
    
      const handleFormSubmit  = async (values) => {
        // console.log('selectedData - ', selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits)
        await UpdatetFacilityData(selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits);
        handleSubmit(true);
        closeDialog();
        /*if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
          console.log('Selected items at parent', selectedItems)
          UpdatetFacilityData(selectedItems);
        }
        handleSubmit(values);
        */
      };
    
      const updateSelectedItems = (selectedItems) => {
         // console.log('Selected items at parent', selectedItems)
          selectedAccessGroups = selectedItems;
      }
    
        const updateSelectedIncludes = (selectedItems) => {
           // console.log('Selected items at parent', selectedItems)
            selectedIncludePropUnits = selectedItems;
        }
    
        const updateSelectedExcludes = (selectedItems) => {
           // console.log('Selected items at parent', selectedItems)
            selectedExcludePropUnits = selectedItems;
        }
    
      const UpdatetFacilityData = async (selectedAccessGroups, selectedIncludePropUnits, selectedExcludePropUnits) => {
        showLoader();
        let obj = {};
        obj["screenType"] = "Edit";
        obj["id"] = eventObject.facilityId;
        obj["companyid"] = eventObject.selectedCompanyId
        obj["name"] = initialState.loginUserName;
        obj["updatedBy"] = initialState.loginUserPersonId;
        let affectedPU = [];
        let IncludeinAffectedList = [];
        let ExcludeInAffectedList = [];
        if (Array.isArray(selectedAccessGroups)){
          selectedAccessGroups.forEach((item) => {
            let obj1 = {};
            obj1["ConcatID"] = item.ConcatID;
            obj1["PropertyID"] = item.PropertyID;
            obj1["FloorID"] = item.FloorID;
            obj1["EntranceID"] = item.EntranceID;
            obj1["ConnectedType"] = item.Type;
            affectedPU.push(obj1);
          })
        }
    
        if (Array.isArray(selectedIncludePropUnits)){
          selectedIncludePropUnits.forEach((item) => {
            let obj1 = {};
            obj1["ID"] = item.ID;
            obj1["Name"] = item.Name;
            IncludeinAffectedList.push(obj1);
          })
        }
    
        if (Array.isArray(selectedExcludePropUnits)){
          selectedExcludePropUnits.forEach((item) => {
            let obj1 = {};
            obj1["ID"] = item.ID;
            obj1["Name"] = item.Name;
            ExcludeInAffectedList.push(obj1);
          })
        }
    
        obj["affectedPUDetailedData"] = affectedPU;
        obj["IncludeinAffectedList"] = IncludeinAffectedList;
        obj["ExcludeInAffectedList"] = ExcludeInAffectedList;
    
         await addEditFacilities(obj).then((result) => {
            hideLoader();
            toast.success("Successfully added", { autoClose: 2000 });
            closeDialog();
         }, error => {
          hideLoader();
        });
        //  console.log('save obj - ', obj);
      };

      const toggleAccesGroupEditorDialog = (item) => {
        console.log(item);
        const dialogValues = {AccessGroupData: OptionsAccessGroup, itemData: item, facilityId: eventObject.facilityId, facilityName: eventObject.FacilityName}
        setAccessGroupModalState((prevState) => ({
          ...prevState,
          AccessGroupDialogOpen: !accessGroupModalState.AccessGroupDialogOpen,
          AccessGroupModalObject: dialogValues
        }));
      };

      const handleFormAccessGroupSubmit = async () => {
        try {
          await getAMSVendorSyncAccessGroup();  // Wait for the first call to complete
          getFacilityDataByID(eventObject.facilityId);  // Then proceed to the next call
        } catch (error) {
          console.error("Error in getting AMS Vendor Sync Access Group:", error);
          // Handle the error (e.g., show a notification to the user)
        }
      }

      // const getAMSVendorSyncAccessGroup = () => {
      //   showLoader();
      //   getAMSSyncAccessGroup({
      //     companyId: selectedCompanyId
      //   }).then((result) => {
      //     hideLoader();
      //     if (result.isSuccess) {
      //       amssynccompanyAccessGroupList = result.data;
      //     }
      //   }, error => {
      //     hideLoader();
      //   });
      // }

      const getAMSVendorSyncAccessGroup = () => {
        return new Promise((resolve, reject) => {
          showLoader();
          getAMSSyncAccessGroup({
            companyId: selectedCompanyId
          }).then((result) => {
            hideLoader();
            if (result.isSuccess) {
              amssynccompanyAccessGroupList = result.data;
              resolve(result);  // Resolve the promise when the call completes successfully
            } else {
              reject(new Error("Failed to fetch AMS vendor sync access group."));  // Reject in case of failure
            }
          }, error => {
            hideLoader();
            reject(error);  // Reject in case of an error
          });
        });
      }

      const getFacilityDataByID = (FacilityId) => {
        showLoader();
        getFacilityDetailByFacilityId({
          FacilityId: FacilityId
        }).then((result) => {
          hideLoader();
          if(result.data.isSuccess){
            setAccessPointData(result.data.data, 'mergeamsdata');
          }
        }, error => {
          hideLoader();
        });
      }

      const setAccessPointData = async (item, type) => {
        showLoader();
        let propertyUnitList = propertyUnitDetails;
        if(propertyUnitList.length <= 0){
          propertyUnitList = await getPropertyUnitData();
        }

        let tempAccessGroupList = eventObject.groupData;
        //if(tempAccessGroupList.length <= 0){
          tempAccessGroupList = await getAccessGroupData();
        //}
        const OptionsPUIncluded = [];
        const OptionsPUExcluded = [];
    
        const selectedIdsPUInc = [];
        const selectedIdsPUExc = [];
    
        if(Array.isArray(item.IncludedPU)){
          item.IncludedPU.forEach(incItem => {
            selectedIdsPUInc.push(incItem.PropertyUnitId);
          })
        }
        if(Array.isArray(item.ExcludedPU)){
          item.ExcludedPU.forEach(excItem => {
            selectedIdsPUExc.push(excItem.PropertyUnitId);
          })
        }
    
        if(Array.isArray(propertyUnitList)){
          propertyUnitList.forEach(puItem => {
            const itemPuInc = Object.assign({}, puItem);
            const itemPuExc = Object.assign({}, puItem);
            itemPuInc.checked = (selectedIdsPUInc.includes(itemPuInc.ID))? true: false;
            itemPuExc.checked = (selectedIdsPUExc.includes(itemPuExc.ID))? true: false;
            OptionsPUIncluded.push(itemPuInc);
            OptionsPUExcluded.push(itemPuExc);
          })
        }
        let vendorAccessGroupSelectedData =   item.AccessGroup;
        if (!Array.isArray(vendorAccessGroupSelectedData)) {
          vendorAccessGroupSelectedData = [];
        }
        if (Object.isFrozen(vendorAccessGroupSelectedData) || Object.isSealed(vendorAccessGroupSelectedData)) {
          vendorAccessGroupSelectedData = [...vendorAccessGroupSelectedData]; // Clone the array
        }
        let filteredAccessGroups = amssynccompanyAccessGroupList.filter(group => 
          group.type === 'custom' && group.accessPoints && group.accessPoints.some(accessPoint => accessPoint.vendorId === item.FacilityId)
        );
        filteredAccessGroups.forEach((filterItem) => {
          let objGroup = {};
          objGroup['AccessGroup'] = filterItem.name;
          objGroup['AccessId'] = filterItem.vendorAccessGroupId;
          objGroup['AccessType'] = filterItem.type;
          objGroup['ConcatID'] = filterItem.vendorAccessGroupId + '_0_0';
          objGroup['ConcatName'] = filterItem.name;
          //objGroup['amsAccessGroupId'] = filterItem.vendorAccessGroupId;
          if (Array.isArray(vendorAccessGroupSelectedData)) {
            vendorAccessGroupSelectedData.push(objGroup);
          }
        });

        // ----------------------
        // selectedGroup: item.AccessGroup, groupData: accessGroupDetails
        if(tempAccessGroupList){
          OptionsAccessGroup = prepareAccessGroupData(OptionsAccessGroup, vendorAccessGroupSelectedData);
          MarkAccessGroupList(OptionsAccessGroup, vendorAccessGroupSelectedData);
        }
       
        eventObject.selectedCompanyId = selectedCompanyId;
        eventObject.selectedGroup = vendorAccessGroupSelectedData;
        eventObject.groupData = tempAccessGroupList;
        eventObject.OptionsPUIncluded = OptionsPUIncluded;
        eventObject.OptionsPUExcluded = OptionsPUExcluded;
        eventObject.OptionsAccessGroup = OptionsAccessGroup;
        // eventObject.item.IncludedPU = item.IncludedPU;
        // eventObject.item.ExcludedPU = item.ExcludedPU;
        setFacilityIncludedPU(item.IncludedPU);
        setFacilityExcludedPU(item.ExcludedPU);
        hideLoader();
        console.log(eventObject);
      };

      const toggleIncExclPUDialog = async (item, type) => {
        console.log('toggleIncExclPUDialog -- ', item);

        let propertyUnitList = propertyUnitDetails;
        if(propertyUnitList.length <= 0){
          propertyUnitList = await getPropertyUnitData();
        }
        const OptionsPUIncluded = [];
        const OptionsPUExcluded = [];
        const selectedIdsPUInc = [];

        if(Array.isArray(item)){
          item.forEach(incItem => {
            selectedIdsPUInc.push(incItem.PropertyUnitId);
          })
        }

        if(type === "INCLPU"){
          
          if(Array.isArray(propertyUnitList)){
            propertyUnitList.forEach(puItem => {
              const itemPuInc = Object.assign({}, puItem);
              itemPuInc.checked = (selectedIdsPUInc.includes(itemPuInc.ID))? true: false;
              OptionsPUIncluded.push(itemPuInc);
            })
          }
        }
        else{
          if(Array.isArray(propertyUnitList)){
            propertyUnitList.forEach(puItem => {
              const itemPuExc = Object.assign({}, puItem);
              itemPuExc.checked = (selectedIdsPUInc.includes(itemPuExc.ID))? true: false;
              OptionsPUExcluded.push(itemPuExc);
            })
          }
        }
        
        let InclExcludePU = [];
        if(type === 'INCLPU'){
          InclExcludePU = OptionsPUIncluded;
        }
        else{
          InclExcludePU = OptionsPUExcluded;
        }
        const dialogValues = {type: type, OptionsPU: InclExcludePU, itemData: item, facilityId: eventObject.facilityId, facilityName: eventObject.FacilityName}
        setInclExclPUModalState((prevState) => ({
          ...prevState,
          InclExclPUDialogOpen: !InclExclPUModalState.InclExclPUDialogOpen,
          InclExclPUModalObject: dialogValues
        }));
      };

      const closeIncExclPUDialog = () => {
        setInclExclPUModalState((prevState) => ({
          ...prevState,
          InclExclPUDialogOpen: false,
          InclExclPUModalObject: {}
        }));
      }

      const {
        AccessGroupModalObject,
        AccessGroupDialogOpen,
      } = accessGroupModalState;

      const {
        InclExclPUModalObject,
        InclExclPUDialogOpen,
      } = InclExclPUModalState;

      const convertAccessGroupToHeirarchy = (data) => {
        const grouped = {};
      
        data.forEach(item => {
          const [propertyId, entranceID, floorId] = item.ConcatID.split('_');
      
          // Skip if AccessId or ParentId is 0
          const accessType = item.Type;
          if(accessType === 'custom'){
            if (!grouped[propertyId]) {
              grouped[propertyId] = {
                Property: item.ConcatName + '*', // Extract property name
                Children: {}
              };
            }
          }
          else{
            if (!grouped[propertyId]) {
              grouped[propertyId] = {
                Property: item.ConcatName.split('-')[0], // Extract property name
                Children: {}
              };
            }
        
            // Group by ParentId (within PropertyId)
            if (!grouped[propertyId].Children[entranceID]) {
              grouped[propertyId].Children[entranceID] = {
                Entrance: item.ConcatName.split('-')[1], // Extract parent name
                Children: []
              };
            }
        
            // Add child to the Parent
            if (floorId && floorId !== '0') {
              grouped[propertyId].Children[entranceID].Children.push({
                AccessId: item.AccessId,
                AccessGroup: item.AccessGroup,
                Floor: item.ConcatName.split('-')[2],
              });
            }
          }
          // Group by PropertyId
          
        });
      
        return grouped;
      };

      return(
        <Fragment>
        <div>
            <div className="breadcrumb d-flex justify-content-between align-items-center search-header o-hidden mb-3">
              <h3>
                Aksesspunkt <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{eventObject.facilityName}</span>, 
                <span style={{ fontSize: '1.1em' }}>{PlacementName}</span>
              </h3>

                <div className="viewer_actions d-flex align-items-center justify-content-end gap-2 mb-4">
                  <Button className="mb-3" variant="primary" onClick={closeDialog} >
                      <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                      Tilbake
                  </Button>
                  <Button className="mb-3 ml-3"  onClick={() => handleFormSubmit(accessData)} variant="primary"  >
                      <BiSave  size={17}></BiSave>   Lagre endringer
                  </Button>
                </div>
                
                
            </div>
            <Row>
            {/* <Col md={3}>
              <Card body className="mb-4">
                <div className="create_event_wrap">
                  <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <h4><i className="i-Key text-20 me-1" /> Aksesspunkt</h4>
                  </div>

                  <ul className="list-group" id="external-events" >
                    <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          {eventObject.facilityName}
                    </li>
                    <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          <i className="i-Map-Marker text-20 me-1" /> 
                          {PlacementName}
                    </li>
                  </ul>
                </div>
              </Card>
            </Col> */}
              {/* <Col md={3}>
                <Card body className="mb-4">
                  <h4><i className="i-Building text-20 me-1" /> Tilgangsgruppe</h4>
                  <Form>
                    <Form.Group>
                      {
                          <MultiselectTreeCtrl refId={'access-groupx'} outSelectedItem={updateSelectedItems} options={OptionsAccessGroup}></MultiselectTreeCtrl>
                      }
                    </Form.Group>
                  </Form>
                </Card>
              </Col> */}
              <Col md={3}>
              <Card body className="mb-4 o-hidden">
                <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <span><i className="i-Home1 text-20 me-1" /> <strong>Tilgangsgruppe</strong> </span>
                    <div className="d-flex gap-2">
                        <span className="cursor-pointer text-primary" onClick={(e) => toggleAccesGroupEditorDialog(accessGroupList)}>
                        {'+ Legg til/redigering'}
                        </span>
                    </div>
                </div>

                <Table bordered className="table table-bordered tbl-custom">
      <tbody>
        {groupedData &&
          Object.keys(groupedData).map((propertyId) => {
            const property = groupedData[propertyId];
            return (
              <React.Fragment key={propertyId}>
                {/* Property Level */}
                <tr>
                  <td colSpan={3}>
                    <strong>{property.Property}</strong>
                  </td>
                </tr>
                
                {/* Loop through the Entrance (Children of Property) */}
                {Object.keys(property.Children).map((entranceId) => {
                  const entrance = property.Children[entranceId];
                  return (
                    <React.Fragment key={entranceId}>
                      {/* Entrance Level */}
                      <tr>
                        <td colSpan={3} style={{ paddingLeft: '2em' }}>
                          {entrance.Entrance}
                        </td>
                      </tr>
                      
                      {/* Loop through the Floors (Children of Entrance) */}
                      {entrance.Children.map((floor, idx) => {
                        return (
                          <tr key={idx}>
                            <td style={{ paddingLeft: '6em' }}>
                              {floor.Floor}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            );
          })}
      </tbody>
    </Table>

                {/* <div>
                  {Object.keys(groupedData).map((propertyId) => {
                    const property = groupedData[propertyId];
                    return (
                      <div key={propertyId}>
                        <div><strong>{property.Property}</strong></div>
                        {Object.keys(property.Children).map((entranceId) => {
                          const entrance = property.Children[entranceId];
                          return (
                            <div key={entranceId} style={{ marginLeft: '2em' }}>
                              <div>{entrance.Entrance}</div>
                              {entrance.Children.map((floor, idx) => (
                                <div key={idx} style={{ marginLeft: '6em' }}>
                                 {floor.Floor}
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div> */}
                
                
              </Card>
              </Col>
              {/* <Col md={3}>
                <Card body className="mb-4">
                  <h4><i className="i-Home1 text-20 me-1" /> Inkluder eiendomsenheter</h4>
                  <Form>
                    <Form.Group>
                        {
                          <MultiselectTreeCtrl refId={'include-propunits'}   outSelectedItem={updateSelectedIncludes} options={OptionsPUIncluded}></MultiselectTreeCtrl>
                        }
                    </Form.Group>
                  </Form>
                </Card>
              </Col> */}
              <Col md={3}>
              <Card body className="mb-4 o-hidden">
                <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <span><i className="i-Home1 text-20 me-1" /> <strong>Inkluder enheter</strong> </span>
                    <div className="d-flex gap-2">
                        <span className="cursor-pointer text-primary" onClick={(e) => toggleIncExclPUDialog(FacilityIncludedPU,'INCLPU')}>
                        {'+ Legg til/redigering'}
                        </span>
                    </div>
                </div>
                
                <Table bordered className="table table-bordered tbl-custom">
                  <tbody >
                    {FacilityIncludedPU && FacilityIncludedPU.map((includePUGroup, index) => (
                          <tr key={'IncludePUGroup' + index}> 
                              <td>
                              {/*  */}
                              <span className="cursor-pointer text-primary">
                                  {includePUGroup.PropertyUnitName}
                              </span> 
                                  
                              </td>
                          </tr>
                      ))}
                  </tbody>
                </Table>
              </Card>
              </Col>
              <Col md={3}>
              <Card body className="mb-4 o-hidden">
                
                <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <span><i className="i-Home1 text-20 me-1" /> <strong>Ekskluder enheter</strong> </span>
                    <div className="d-flex gap-2">
                        <span className="cursor-pointer text-primary" onClick={(e) => toggleIncExclPUDialog(FacilityExcludedPU,'EXCLPU')}>
                        {'+ Legg til/redigering'}
                        </span>
                    </div>
                </div>
                
                <Table bordered className="table table-bordered tbl-custom">
                  <tbody >
                    {FacilityExcludedPU  && FacilityExcludedPU.map((excludePUGroup, index) => (
                          <tr key={'IncludePUGroup' + index}> 
                              <td>
                              {/* onClick={() => handleAccessGroupClick(accessGroupItem)} */}
                              <span className="cursor-pointer text-primary">
                                  {excludePUGroup.PropertyUnitName}
                              </span> 
                                  
                              </td>
                          </tr>
                      ))}
                  </tbody>
                </Table>
              </Card>
              </Col>
              {/* <Col md={3}>
                <Card body className="mb-4">
                  <h4><i className="i-Home1 text-20 me-1" /> Ekskluder eiendomsenheter</h4>
                  <Form>
                    <Form.Group>
                        {
                          <MultiselectTreeCtrl refId={'exclude-propunits'}   outSelectedItem={updateSelectedExcludes} options={OptionsPUExcluded}></MultiselectTreeCtrl>
                        }
                    </Form.Group>
                  </Form>
                </Card>
              </Col> */}
            </Row>
        </div>
        {loader}
        {
          
          AccessGroupDialogOpen &&
          <AccessPointModal
            open={AccessGroupDialogOpen}
            eventObject={AccessGroupModalObject}
            handleSubmit={handleFormAccessGroupSubmit}
            closeDialog={toggleAccesGroupEditorDialog}
          />
        }

        {
          InclExclPUDialogOpen &&
          <AccessPointIncExclPU
            open={InclExclPUDialogOpen}
            eventObject={InclExclPUModalObject}
            handleSubmit={handleFormAccessGroupSubmit}
            closeDialog={closeIncExclPUDialog}
          />
        }
        
        </Fragment>
      );
}

export default AccessPointDetails;

export const getDefaultSelectedFromOptions = ((options: any) => {
    const checkedItems = [];
    if(Array.isArray(options)){
        options.forEach(item => {
            if(item.checked){
                checkedItems.push(item);
            }
        })
    }
    return checkedItems;
})

export const prepareDefaultSelectedAccessGroup = (treeOptions: any, selectedItems: any) => {
    console.log('prepareDefaultSelectedAccessGroup', selectedItems);
    const optionsByConcatId = getOptionsByConcatId(treeOptions);
    const refinedItems: any = [];
    if(Array.isArray(selectedItems)){
        selectedItems.forEach((item: any) => {

            const optionItem: any = optionsByConcatId[item.ConcatID];
            if(optionItem){
                const newItem = {
                    ConcatID: optionItem.ConcatID,
                    PropertyID: optionItem.PropertyID,
                    FloorID: optionItem.FloorID,
                    EntranceID: optionItem.EntranceID,
                    ConnectedType: optionItem.Type,
                    Type: optionItem.Type,
                    ConcatName: optionItem.ConcatName,
                    label: optionItem.label
                }
                refinedItems.push(newItem);
            }
        })
    }
    return refinedItems;
};

export const getOptionsByConcatId =  (treeOptions: any) => {
    let optionsByConcatId = {};
    if(Array.isArray(treeOptions)){
        treeOptions.forEach(item => {
            optionsByConcatId[item.ConcatID] = item;
            if(Array.isArray(item.children) && item.children.length){
                const resultForChild = getOptionsByConcatId(item.children);
                optionsByConcatId = {...optionsByConcatId, ...resultForChild};
            }
        })
    }
    return optionsByConcatId;
}

export const prepareAccessGroupData = (options: any, selectedItems: any) => {
  // console.log('Options', options);
  // console.log('selectedItems', selectedItems);

  let tempdata = JSON.parse(JSON.stringify(options));

  if(tempdata && Array.isArray(tempdata) && tempdata.length > 0){
    // console.log('USEEFFECT ---------------------------------- ',);
    // Set already checked to false
    tempdata.forEach((item) => {
      if(item.checked === true){
        item.checked =  false;
      }
      let entrance = item.children;
      if(entrance && Array.isArray(entrance) && entrance.length > 0){
        entrance.forEach((entraceitem) => {
          if(entraceitem.checked === true){
            entraceitem.checked =  false;
          }
          let floor = entraceitem.children;
          if(floor && Array.isArray(floor) && floor.length > 0){
            floor.forEach((floorItem) => {
              if(floorItem.checked === true){
                floorItem.checked =  false;
              }
            });
          }
        });
      }
    });

    // let

    //Select preselect data
    if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
      tempdata.forEach((item) => {
        let ConcatID = item.ConcatID;
        if(item.checked === true){
          item.checked =  false;
        }
        var check = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'Direct');
        if(check && check.length > 0){
          item.checked = true;
        }
        let entrance = item.children;
        if(entrance && Array.isArray(entrance) && entrance.length > 0){
          entrance.forEach((entraceitem) => {
            var entranceCheck = selectedItems.filter(a => a.ConcatID === entraceitem.ConcatID&& a.AccessType === 'Direct');
            if(entranceCheck && entranceCheck.length > 0){
              entraceitem.checked = true;
            }
            let floor = entraceitem.children;
            if(floor && Array.isArray(floor) && floor.length > 0){
              floor.forEach((floorItem) => {
                var floorCheck = selectedItems.filter(a => a.ConcatID === floorItem.ConcatID&& a.AccessType === 'Direct');
                if(floorCheck && floorCheck.length > 0){
                  floorItem.checked = true;
                }
              });
              entraceitem.children = floor;
            }
          });
          item.children = entrance;
        }
      });
    }
  }


  return refineOption(tempdata);
};

export const refineOption = (data: any) => {
  if(Array.isArray(data) && data.length){
    data.forEach(item => {
      item.checked = false;
      if(item.checked == null || item.checked == false){
        delete item.checked;
      }
      if(Array.isArray(item.children)){
        item.children = refineOption(item.children);
      }
    })
  }
  return data;
};